export default "__VITE_ASSET__DqR_SN7A__"